import { WordAdapter } from './word-adapter';
import { OutlookAdapter } from './outlook-adapter';
import { PowerPointAdapter } from './powerpoint-adapter';
import { ExcelAdapter } from './excel-adapter';
export { WordAdapter } from './word-adapter';
export { OutlookAdapter } from './outlook-adapter';
export { PowerPointAdapter } from './powerpoint-adapter';
export { ExcelAdapter } from './excel-adapter';
/**
 * Convert Office.HostType to our OfficeHostType
 */
export function getOfficeHostType(host) {
    if (!host)
        return 'unknown';
    switch (host) {
        case Office.HostType.Word:
            return 'word';
        case Office.HostType.Outlook:
            return 'outlook';
        case Office.HostType.PowerPoint:
            return 'powerpoint';
        case Office.HostType.Excel:
            return 'excel';
        default:
            return 'unknown';
    }
}
/**
 * Get the Office app variable to include in pipeline execution requests
 */
export function getOfficeAppVariable(hostType) {
    const map = {
        word: 'OfficeAddInWord',
        excel: 'OfficeAddInExcel',
        powerpoint: 'OfficeAddInPowerPoint',
        outlook: 'OfficeAddInOutlook',
    };
    const key = map[hostType];
    return key ? { [key]: 'true' } : {};
}
/**
 * Factory function to create the appropriate host adapter
 */
export function createHostAdapter(hostType) {
    switch (hostType) {
        case 'word':
            return new WordAdapter();
        case 'outlook':
            return new OutlookAdapter();
        case 'powerpoint':
            return new PowerPointAdapter();
        case 'excel':
            return new ExcelAdapter();
        default:
            // Default to Word adapter for unknown hosts
            console.warn(`[HostAdapter] Unknown host type: ${hostType}, defaulting to Word`);
            return new WordAdapter();
    }
}
